import React, { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

function PaqueteriasCreate() {
  const { user } = useContext(AuthContext);
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [diasEntrega, setDiasEntrega] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);

  const savePaqueteria = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(URL_PAQUETERIAS, { name, diasEntrega: Number(diasEntrega) || 0 }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: "Crear Paqueteria", detalle: name, user: user.id
        }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        setName("");
        setDiasEntrega(0);
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response?.data}` });
      });
  };

  return (
    <div className="container">
      <h3 align="center">Crea una Paqueteria</h3>
      <Form onSubmit={savePaqueteria}>
        <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
          <Label className="mr-sm-2">Paqueteria</Label>
          <Input
            type="text"
            placeholder="Nombre de la paqueteria"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
          <Label className="mr-sm-2">Días de entrega</Label>
          <Input
            type="number"
            min="0"
            placeholder="0"
            value={diasEntrega}
            onChange={(e) => setDiasEntrega(e.target.value)}
          />
        </FormGroup>
        <Row className="container">
          <Button type="submit" className="btn btn-success" disabled={!validaBoton}>Guardar</Button>
          <Button color="danger" href="/MenuArticulos">Regresar</Button>
        </Row>
      </Form>
    </div>
  );
}

export default PaqueteriasCreate;
